const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

// Mapear asesor del backend a formato UI de tabla
function mapAsesorToRow(asesor) {
  return {
    id_docente: asesor.id_asesor,
    id_asesor: asesor.id_asesor,  // Para compatibilidad con NuevoGrupoModal
    id: asesor.id_asesor,          // Para compatibilidad general
    name: asesor.nombre_completo || '',
    nombre_completo: asesor.nombre_completo || '',  // Para compatibilidad con NuevoGrupoModal
    // Información de campus principal (viene del serializer EscAsesorSerializer)
    id_campus: asesor.id_campus,
    campus: asesor.campus_nombre || '',
    empCode: asesor.numero_empleado || '',
    email: asesor.email_institucional || '',
    academy: asesor.academia_nombre || '', // Del serializer
    academia_nombre: asesor.academia_nombre || '',
    institucion_nombre: asesor.institucion_nombre || '',
    ciclo_nombre: asesor.ciclo_nombre || '',
    nationality: asesor.nacionalidad || '',
    country: asesor.lugar_nacimiento || '',
    status: asesor.estado_asesor === 'ACTIVO' ? 'active' 
          : asesor.estado_asesor === 'BAJA' ? 'baja' 
          : 'inactive',
    advisorType: asesor.tipo_asesor || '',
    tipo_asesor: asesor.tipo_asesor || '',
    // Campos adicionales para edición
    id_institucion: asesor.id_institucion,
    id_academia: asesor.id_academia,
    primer_ciclo_escolar: asesor.primer_ciclo_escolar,
  };
}

// Mapear formulario UI a payload backend
function mapFormToPayload(form, isUpdate = false) {
  console.log('[teachers.js] mapFormToPayload - form recibido:', form, 'isUpdate:', isUpdate);
  
  const toInt = (v) => {
    if (v === undefined || v === null || v === '') return null;
    const n = parseInt(String(v), 10);
    return Number.isFinite(n) ? n : null;
  };

  // Mapear modalidad UI a backend enum
  const modalidadUi = form.modality;
  let modalidadBackend;
  if (modalidadUi === 'Presencial') {
    modalidadBackend = 'PRESENCIAL';
  } else if (modalidadUi === 'En línea') {
    modalidadBackend = 'EN_LINEA';
  } else if (modalidadUi === 'Virtual' || modalidadUi === 'Híbrida' || modalidadUi === 'Mixta') {
    modalidadBackend = 'VIRTUAL_HIBRIDA';
  } else if (!isUpdate) {
    // En creación, si no se selecciona nada, usar PRESENCIAL por defecto
    modalidadBackend = 'PRESENCIAL';
  } else {
    // En actualización, si no se manda nada, dejamos que el backend preserve el valor existente
    modalidadBackend = undefined;
  }

  // Mapear estado del asesor. En creación forzamos ACTIVO para que
  // siempre aparezca en la lista (el backend solo lista estado_asesor='ACTIVO').
  const estadoUi = form.status;
  const estadoMapeado = isUpdate
    ? (estadoUi === 'ACTIVO' ? 'ACTIVO'
      : estadoUi === 'BAJA' ? 'BAJA'
      : estadoUi === 'INACTIVO' ? 'INACTIVO'
      : 'ACTIVO')
    : 'ACTIVO';

  // Sexo: enviar tal cual ('M' | 'F' | 'O' | '')
  const sexoBackend = (form.sexo || '').toString().toUpperCase();

  // Ficha médica: si el usuario marca "NO", limpiar campos dependientes
  const tieneSeguroRaw = form.fmTieneSeguro;
  let fmTieneServicioMedico = null;
  if (tieneSeguroRaw === 'SI' || tieneSeguroRaw === true || tieneSeguroRaw === 1 || tieneSeguroRaw === '1') {
    fmTieneServicioMedico = true;
  } else if (tieneSeguroRaw === 'NO' || tieneSeguroRaw === false || tieneSeguroRaw === 0 || tieneSeguroRaw === '0') {
    fmTieneServicioMedico = false;
  }

  const fmServicioMedico = fmTieneServicioMedico === true ? (form.fmServicioMedico || null) : null;
  const fmNumeroAfiliacion = fmTieneServicioMedico === true ? (form.fmNumeroAfiliacion || null) : null;
  const fmNumeroClinica = fmTieneServicioMedico === true ? (form.fmNumeroClinica || null) : null;
  const fmFechaSeguro = fmTieneServicioMedico === true ? (form.fmFechaSeguro || null) : null;

  const payload = {
    nombre_completo: form.fullName || '',
    numero_empleado: form.employeeCode || '',
    sexo: sexoBackend || null,
    curp: form.curp || '',
    rfc: form.rfc || '',
    email_institucional: form.instEmail || '',
    email_personal: form.personalEmail || '',
    telefono: form.phone || '',
    direccion: form.address || '',
    fecha_nacimiento: form.birthDate || null,
    lugar_nacimiento: form.originCountry || '',
    nacionalidad: form.nationality || '',
    ultimo_grado_academico: form.lastGrade || '',
    especialidad: form.specialty || '',
    fecha_ingreso: form.joinDate || null,
    // Solo incluir modalidad_trabajo cuando tengamos un valor definido
    modalidad_trabajo: modalidadBackend,
    horas_disponibles: toInt(form.hours),
    // Asegurar que estado_asesor siempre tenga un valor válido
    estado_asesor: estadoMapeado,
    // Tipo de asesor (categoría informativa: ASESOR | ASESOR_ADMINISTRATIVO)
    tipo_asesor: (form.advisorType && String(form.advisorType).trim() !== '')
      ? String(form.advisorType).trim()
      : (isUpdate ? undefined : 'ASESOR'),
    id_institucion: toInt(form.institution),
    id_academia: toInt(form.academy),
    primer_ciclo_escolar: toInt(form.firstCycle),
    // Horarios disponibles (array de turnos seleccionados)
    horarios_disponibles_input: Array.isArray(form.schedule) ? form.schedule : (form.schedule ? [form.schedule] : []),
    // Campus input para relación intermedia
    id_campus_input: toInt(form.campus),
    // Ficha médica (siempre enviar para permitir limpiar al cambiar SI->NO)
    fm_tiene_servicio_medico: fmTieneServicioMedico,
    fm_servicio_medico: fmServicioMedico,
    fm_numero_afiliacion: fmNumeroAfiliacion,
    fm_numero_clinica: fmNumeroClinica,
    fm_fecha_seguro: fmFechaSeguro,
  };
  
  // En actualizaciones, filtrar campos que son null o vacíos para no sobrescribir valores existentes
  if (isUpdate) {
    const filteredPayload = {};
    // Campos de ficha médica: SIEMPRE enviar (incluso null) para permitir
    // que el usuario limpie el servicio médico al cambiar SI->NO.
    const fichaMedicaKeys = new Set([
      'fm_tiene_servicio_medico',
      'fm_servicio_medico',
      'fm_numero_afiliacion',
      'fm_numero_clinica',
      'fm_fecha_seguro',
    ]);
    for (const [key, value] of Object.entries(payload)) {
      // Siempre incluir campos requeridos
      if (key === 'nombre_completo' || key === 'numero_empleado') {
        filteredPayload[key] = value;
        continue;
      }
      // Campos de ficha médica: enviar siempre (permite null)
      if (fichaMedicaKeys.has(key)) {
        filteredPayload[key] = value;
        continue;
      }
      // Para horarios, siempre incluir si hay valores
      if (key === 'horarios_disponibles_input') {
        if (Array.isArray(value) && value.length > 0) {
          filteredPayload[key] = value;
        }
        continue;
      }
      // Para otros campos, solo incluir si tienen valor
      if (value !== null && value !== '' && value !== undefined) {
        filteredPayload[key] = value;
      }
    }
    console.log('[teachers.js] mapFormToPayload - payload filtrado (update):', filteredPayload);
    return filteredPayload;
  }
  
  console.log('[teachers.js] mapFormToPayload - payload generado:', payload);
  return payload;
}

export async function getTeachers() {
  try {
    console.log('[teachers.js] Llamando a:', `${API_BASE}/escolar/asesores/`);
    const res = await fetch(`${API_BASE}/escolar/asesores/`, {
      headers: getAuthHeaders()
    });
    console.log('[teachers.js] Status:', res.status);
    if (!res.ok) {
      console.error('[teachers.js] Error en respuesta:', res.status, res.statusText);
      return [];
    }
    const data = await res.json();
    console.log('[teachers.js] Datos recibidos:', data);
    console.log('[teachers.js] Total asesores:', data.length);
    
    const mapped = Array.isArray(data) ? data.map(mapAsesorToRow) : [];
    console.log('[teachers.js] Asesores mapeados:', mapped);
    return mapped;
  } catch (err) {
    console.error('[teachers.js] Error al cargar asesores:', err);
    return [];
  }
}

export async function createTeacher(form) {
  const payload = mapFormToPayload(form);
  console.log('[teachers.js] Payload para crear asesor:', payload);
  
  try {
    const res = await fetch(`${API_BASE}/escolar/asesores/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const error = await res.json();
      console.error('[teachers.js] Error del backend:', error);
      throw new Error(JSON.stringify(error));
    }
    const created = await res.json();
    console.log('[teachers.js] Asesor creado exitosamente:', created);
    // Dispatch event para recargar tabla
    window.dispatchEvent(new CustomEvent('docente:created'));
    return created;
  } catch (err) {
    console.error('[teachers.js] Error al crear asesor:', err);
    throw err;
  }
}

export async function getTeacher(id) {
  if (!id) {
    throw new Error('ID de asesor no proporcionado');
  }
  
  try {
    const res = await fetch(`${API_BASE}/escolar/asesores/${id}/`, {
      headers: getAuthHeaders()
    });
    if (!res.ok) throw new Error('Error al obtener asesor');
    const data = await res.json();
    
    console.log('[teachers.js] Asesor obtenido:', data);
    
    // Mapear backend a formato UI de formulario
    return {
      id_asesor: data.id_asesor,
      id: data.id_asesor,
      fullName: data.nombre_completo || '',
      institution: data.id_institucion ? String(data.id_institucion) : '',
      institucion_nombre: data.institucion_nombre || '',
      employeeCode: data.numero_empleado || '',
      campus: data.id_campus ? String(data.id_campus) : '', // Ahora viene del backend
      campus_nombre: data.campus_nombre || '',
      curp: data.curp || '',
      rfc: data.rfc || '',
      instEmail: data.email_institucional || '',
      personalEmail: data.email_personal || '',
      academy: data.id_academia ? String(data.id_academia) : '',
      academia_nombre: data.academia_nombre || '',
      phone: data.telefono || '',
      modality: data.modalidad_trabajo === 'PRESENCIAL' ? 'Presencial'
              : data.modalidad_trabajo === 'EN_LINEA' ? 'En línea'
              : data.modalidad_trabajo === 'VIRTUAL_HIBRIDA' ? 'Mixta'
              : '',
      address: data.direccion || '',
      joinDate: data.fecha_ingreso || '',
      birthDate: data.fecha_nacimiento || '',
      schedule: Array.isArray(data.horarios_disponibles) ? data.horarios_disponibles : [],
      hours: data.horas_disponibles ?? '',
      nationality: data.nacionalidad || '',
      originCountry: data.lugar_nacimiento || '',
      firstCycle: data.primer_ciclo_escolar ? String(data.primer_ciclo_escolar) : '',
      ciclo_nombre: data.ciclo_nombre || '',
      lastGrade: data.ultimo_grado_academico || '',
      status: data.estado_asesor || 'ACTIVO',
      advisorType: data.tipo_asesor || '',
      // Género (M/F/O)
      sexo: data.sexo || '',
      // Ficha médica
      fmTieneSeguro:
        data.fm_tiene_servicio_medico === true || data.fm_tiene_servicio_medico === 1
          ? 'SI'
          : (data.fm_tiene_servicio_medico === false || data.fm_tiene_servicio_medico === 0
              ? 'NO'
              : ''),
      fmServicioMedico: data.fm_servicio_medico || '',
      fmNumeroAfiliacion: data.fm_numero_afiliacion || '',
      fmNumeroClinica: data.fm_numero_clinica || '',
      fmFechaSeguro: data.fm_fecha_seguro || '',
    };
  } catch (err) {
    console.error('[teachers.js] Error al obtener asesor:', err);
    throw err;
  }
}

export async function updateTeacher(id, form) {
  // Validar que el ID existe
  if (!id) {
    throw new Error('ID de asesor no proporcionado');
  }
  
  // Usar isUpdate=true para filtrar campos vacíos y preservar valores existentes
  const payload = mapFormToPayload(form, true);
  console.log('[teachers.js] Actualizando asesor ID:', id, 'Payload:', payload);
  
  try {
    const res = await fetch(`${API_BASE}/escolar/asesores/${id}/`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const error = await res.json().catch(() => ({}));
      console.error('[teachers.js] Error del backend:', error);
      throw new Error(JSON.stringify(error) || 'Error al actualizar asesor');
    }
    const updated = await res.json();
    console.log('[teachers.js] Asesor actualizado:', updated);
    // Dispatch event para recargar tabla
    window.dispatchEvent(new CustomEvent('docente:changed'));
    return updated;
  } catch (err) {
    console.error('[teachers.js] Error al actualizar asesor:', err);
    throw err;
  }
}

  // Filtrar emails que NO tienen aún un usuario en sys_usuarios
  export async function filterEmailsWithoutUser(emails = []) {
    try {
      if (!Array.isArray(emails) || emails.length === 0) {
        return [];
      }
      const res = await fetch(`${API_BASE}/sistema/usuarios/filtrar-no-existentes/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
        body: JSON.stringify({ emails }),
      });
      if (!res.ok) {
        console.error('[teachers.js] Error al filtrar emails sin usuario:', res.status, res.statusText);
        return [];
      }
      const data = await res.json();
      return data.emails_sin_usuario || [];
    } catch (err) {
      console.error('[teachers.js] Error en filterEmailsWithoutUser:', err);
      return [];
    }
  }

export async function deleteTeacher(id) {
  try {
    const res = await fetch(`${API_BASE}/escolar/asesores/${id}/`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    if (!res.ok) throw new Error('Error al eliminar asesor');
    return true;
  } catch (err) {
    console.error('[teachers.js] Error al eliminar asesor:', err);
    throw err;
  }
}

// Alias para compatibilidad con NuevoGrupoModal (pantalla de Grupos)
export async function getAsesores() {
  return getTeachers();
}

// ============================================================================
// EXPEDIENTE DOCUMENTAL DE ASESORES
// ============================================================================

const getAuthHeadersFileUpload = () => {
  const token = localStorage.getItem('authToken');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

/**
 * Obtener documentos del expediente de un asesor.
 */
export async function getDocumentosAsesor(asesorId) {
  const res = await fetch(`${API_BASE}/documental/expedientes-asesores/?id_asesor=${asesorId}`, {
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error('Error al obtener documentos del asesor');
  return res.json();
}

/**
 * Subir documento PDF para un asesor.
 * @param {number} asesorId
 * @param {string} tipoDocumento - CV | TITULO | CEDULA | INE | CURP | COMPROBANTE_DOMICILIO | RFC | CONTRATO
 * @param {File} archivo - Archivo PDF
 */
export async function subirDocumentoAsesor(asesorId, tipoDocumento, archivo) {
  const formData = new FormData();
  formData.append('id_asesor', asesorId);
  formData.append('tipo_documento', tipoDocumento);
  formData.append('archivo', archivo);
  formData.append('nombre_archivo', archivo.name);

  const res = await fetch(`${API_BASE}/documental/expedientes-asesores/`, {
    method: 'POST',
    headers: getAuthHeadersFileUpload(),
    body: formData,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Error al subir documento');
  }
  return res.json();
}

/**
 * Eliminar (soft-delete) un documento de asesor.
 */
export async function eliminarDocumentoAsesor(documentoId) {
  const res = await fetch(`${API_BASE}/documental/expedientes-asesores/${documentoId}/`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  if (!res.ok) throw new Error('Error al eliminar documento');
  return true;
}

/**
 * Obtener URL de descarga de un documento de asesor.
 */
export function getUrlDescargaDocumentoAsesor(documentoId) {
  return `${API_BASE}/documental/expedientes-asesores/${documentoId}/descargar/`;
}
